import { UIDetailsInput } from './UIDetailsInput';

export { UIDetailsInput };
